// extracted by mini-css-extract-plugin
module.exports = {"noDataTitle":"Chart_noDataTitle__2jR2x"};